import Api from '../../common/api';

export async function requestGetBrands(payload) {
  const response = await Api.getApi().request('get', '/brands', { params: { ...payload } });
  const { data, metadata } = response;
  return { data, metadata };
}
